import React, { Component } from "react"
import { Redirect, withRouter } from "react-router-dom"
import { Container, Row, Col } from "react-bootstrap"
import Navegacion from "./Navegacion"
import Mensajes from "./Mensajes"
import Pie from "./Pie.js"
import Sidebar from "react-sidebar"
import axios from "axios";

class Layout extends Component {
  constructor(props) {
    super(props)
    const token = localStorage.getItem("api_token");
    let loggedIn = true
    let rutaActual = this.props.location.pathname
    if (token == null) {
      loggedIn = false
    }

    this.state = {
      sidebarOpen: false,
      loggedIn: loggedIn,
      rutaActual: rutaActual,
      numMensjaes: 0
    };
  }

  componentDidMount() {
    //this.noEditFnc()
  }

  onSetSidebarSwitch = () => {
    let abierto = !(this.state.sidebarOpen)
    this.setState({ sidebarOpen: abierto });
  }

  totalMensajes = (total) => {
    this.setState({ numMensjaes: total });
  }


  render() {
    if (!this.state.rutaActual.includes("/digital")) {
      if (this.state.loggedIn === false) {
        return <Redirect to="/"></Redirect>
      }
    }

    let busca = this.state.rutaActual.split("/")
    let muestraMensaje = false
    let formato = 0
    let ambito_id = 0
    busca.shift()

    if (busca[0] == "escritorio" || busca[0].includes("f")) {
      muestraMensaje = true
      if (busca[0].includes("f")) {
        formato = busca[0].slice(1, -1)
      }
      if (busca[2]) {
        ambito_id = busca[2]
      }
    }

    if (localStorage.ambitos == "0") {
      muestraMensaje = false
    }

    return (
      <div>
        <Navegacion onSetSidebarSwitch={this.onSetSidebarSwitch} muestraMensajes={muestraMensaje} numMensjaes={this.state.numMensjaes} />
        <Container fluid>
          {muestraMensaje ?
            <Sidebar
              sidebarClassName="barra-lateral"
              overlayClassName="barra-lateral-overly"
              sidebar={
                <Mensajes formato={formato} ambito_id={ambito_id} totalMensajes={(e) => this.totalMensajes(e)} />
              }
              open={this.state.sidebarOpen}
              onSetOpen={this.onSetSidebarSwitch}
              defaultSidebarWidth={500}
              pullRight={true}
            >
              <Row>
                <Col xs={12} id="page-content-wrapper">
                  <div className="mt-5">&nbsp;</div>
                  {this.props.children}
                  <div className="mb-4">&nbsp;</div>
                </Col>
              </Row>
            </Sidebar>
            :
            <Row>
              <Col xs={12} id="page-content-wrapper">
                <div className="mt-5">&nbsp;</div>
                {this.props.children}
                <div className="mb-4">&nbsp;</div>
              </Col>
            </Row>
          }
        </Container>
        <Pie />
      </div>
    );
  }
}

export default withRouter(Layout)
